import React from "react";
import RevenueEntry from "./RevenueEntry";

function MaskedRevenueEntry({rank, value, isSelf}) {

    /* we should not be receiving the name from the api, but we will mask it anyway for safety.
    If the user is "self" the name will be displayed. */

    return (
        <RevenueEntry rank={rank} name={"- - -"} value={""} isHighlighted={isSelf} />
    );
}

export default MaskedRevenueEntry;